import React from "react";
import { useTranslation } from "react-i18next";
import { Owner } from "../../../types/modules/admin/Owner";
import OwnerItem from "./OwnerItem";
import { PermissionGate } from "../PermissionGate";
import { PermissionsKey } from "../../../data/permissions";

interface Props {
  owners: Owner[];
}

const OwnersListTable: React.FC<Props> = ({ owners }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal capitalize">{t("id")}</th>
            <th className="p-3 font-normal capitalize">{t("phone")}</th>
            <th className="p-3 font-normal capitalize">{t("name")}</th>
            <th className="p-3 font-normal capitalize">{t("city")}</th>
            <th className="p-3 font-normal capitalize">{t("email")}</th>
            <PermissionGate permissions={[PermissionsKey.UpdateOwner]}>
              <th className="p-3 font-normal capitalize">{t("actions")}</th>
            </PermissionGate>
            <th className="p-3 font-normal capitalize">{t("profile")}</th>
          </tr>
        </thead>
        <tbody className="text-sm">
          {owners.map((owner, ) => (
            <OwnerItem key={owner.id} owner={owner}/>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default OwnersListTable;